import React from 'react';
import { ZapIcon, LeafIcon, ShieldIcon, HeartIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: ZapIcon,
    label: 'Más energía'
  }, {
    icon: LeafIcon,
    label: 'Mejor digestión'
  }, {
    icon: ShieldIcon,
    label: 'Menos alergias'
  }, {
    icon: HeartIcon,
    label: 'Mayor calidad de vida'
  }];
  return <section className="bg-white py-10 md:py-14" data-id="element-11">
      <div className="max-w-4xl mx-auto px-5" data-id="element-12">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-ink text-center mb-6" data-id="element-13">
          Lo que cambia en tu mascota
        </h2>

        <div className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-14">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="bg-gray-50 p-6 md:p-8 rounded-xl text-center" data-id="element-15">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-forest/10 rounded-full mb-3" data-id="element-16">
                  <Icon className="w-6 h-6 text-forest" data-id="element-17" />
                </div>
                <p className="font-semibold text-ink" data-id="element-18">{benefit.label}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}